<template>
  <a-popover
    v-model:open="open"
    placement="bottomRight"
    destroyPopupOnHide
    trigger="click"
    @openChange="openChange"
  >
    <template #content>
      <div
        class="text-center text-[16px] leading-[1em] font-semibold text-font-1"
      >
        {{ $t('yao-qing-cheng-yuan-jia-ru-tuan-dui') }}
      </div>
      <a-divider style="margin: 12px -12px 0" class="w-[calc(100%+24px)]" />
      <div class="p-[16px] w-[320px]">
        <div class="text-12 text-font-50 mb-[10px]">
          {{
            $t(
              'fu-zhi-yi-xia-lian-jie-cheng-yuan-dian-ji-lian-jie-zhu-ce-deng-lu-hou-jia-ru-tuan-dui'
            )
          }}
        </div>
        <ShareLink
          :hasTitle="false"
          :url="link"
          :event="TRACK_EVENT.COPY_TEAM_MEMBER_INVITE_LINK"
          :trackParams="{
            team_id: userInfo?.organization_id,
            team_name: userInfo?.organization_name,
            operator_id: userInfo?.user_id,
            operator_name: userInfo?.username,
          }"
        />
        <div class="text-font-50 mt-[10px] text-12">
          {{ $t('sheng-yu-remain-ge-cheng-yuan-ming-e', [remain]) }}
        </div>
      </div>
    </template>
    <a-button type="primary">{{ $t('tian-jia-cheng-yuan') }}</a-button>
  </a-popover>
</template>

<script lang="ts" setup>
import { createInvitation } from '~/api'
import { ShareLink } from '~/features/template/components/shareLink'

const { $t } = useNuxtApp()

const open = ref(false)

const userInfo = useUserInfo()
const link = ref('')
const num = computed(() => {
  return userInfo.value?.rights?.sub_account_num || 0
})

const remain = computed(() => {
  return userInfo.value?.rights.sub_account_num
})

const openChange = async (v: boolean) => {
  if (userInfo.value?.is_expired || !v || num.value === 0) {
    return
  }

  try {
    const res = await createInvitation()
    if (res.code === 0) {
      link.value = `${location.origin}/center/invite?token=${res.data.token}`
    }
  } catch (error) {
    console.error(error)
  }
}

onBeforeMount(() => {
  useUpdateUser()
})
</script>

<style lang="scss" scoped>
.show-modal-button {
  position: absolute;
  right: 28px;
  top: 148px;
}
</style>
